import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '../../lib/icons';

// Self-contained desktop language dropdown. Closes automatically on route
// change. Presentation identical to the previous inline version.
export function LanguageSelector({ value, languages, onChange, className = '' }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Seleziona lingua"
        aria-expanded={open}
        className="flex items-center gap-1.5 rounded-btn px-2 py-1.5 text-sm text-paelbi-ink/80 transition-colors hover:text-paelbi-brown"
      >
        <Icon name="globe" size={18} />
        <span>{value}</span>
        <Icon name="chevronRight" size={14} className="rotate-90" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-28 overflow-hidden rounded-card border border-paelbi-line bg-white shadow-soft">
          {languages.map((l) => (
            <button
              key={l}
              onClick={() => { onChange(l); setOpen(false); }}
              className={`block w-full px-4 py-2 text-left text-sm hover:bg-paelbi-bg ${l === value ? 'text-paelbi-brown font-semibold' : 'text-paelbi-ink/80'}`}
            >
              {l}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
